var React = require('react');

function SortAscendingInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.00015 16.5858L9.00015 14.5858L10.4144 16L6.70726 19.7071C6.31673 20.0976 5.68357 20.0976 5.29304 19.7071L1.58594 16L3.00015 14.5858L5.00015 16.5858V6H7.00015V16.5858ZM22.0002 6V8H10.0002V6H22.0002ZM22.0002 11V13H12.0002V11H22.0002ZM22.0002 18V16H14.0002V18H22.0002Z","fill":"currentColor"}));
}

SortAscendingInline.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SortAscendingInline;

SortAscendingInline.default = SortAscendingInline;
